import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'services/api';
import AreaOfInnovation from 'models/AreaOfInnovation';

export const areasOfInnovationApi = createApi({
  reducerPath: 'areasOfInnovationApi',
  baseQuery: axiosBaseQuery({
    apiPath: '/api/areas_innovation/',
  }),
  endpoints: builder => ({
    // List ALL areas of innovation
    listAreasOfInnovation: builder.query({
      query: query => ({ params: query }),
      transformResponse: response => {
        if (Array.isArray(response)) {
          return response.map(area => new AreaOfInnovation(area));
        }
        return [];
      },
    }),
  }),
});

export const { useListAreasOfInnovationQuery } = areasOfInnovationApi;
